export default "__VITE_PUBLIC_ASSET__39f18fa0__"